const translations = {
  "en": {
    "Fail to connect. Please try again.": "Fail to connect. Please try again.",
    "Oops...Something went wrong. Please try again.": "Oops...Something went wrong. Please try again."
  },
  "zh-tw": {
    "Fail to connect. Please try again.": "連線失敗，請再試一次。",
    "Oops...Something went wrong. Please try again.": "哎呀，出了一點問題，請再試一次。"
  }
};

export default translations;
